import React, { useEffect, useState } from 'react'

import Loading from '../components/loading/loading'
import KeycloakJS from 'keycloak-js'

const TOKEN_UPDATE_TIME = 20000
const DIRECT_ACCESS_STORAGE_KEY = 'idun_direct_access_key'
const DIRECT_ACCESS_QUERY_PARAMS = ['access_key', 'idun_access_key']

export const DISABLE_AUTH = (process.env.REACT_APP_DISABLE_AUTH === 'true' || process.env.REACT_APP_DISABLE_AUTH === true);

export const KeycloakContext = React.createContext()

function getParamFromSearch(search) {
    const params = new URLSearchParams(search)

    for (const param of DIRECT_ACCESS_QUERY_PARAMS) {
        const value = params.get(param)
        if(value) return value
    }

    return null
}

function getDirectAccessKeyFromUrl() {
    const searchValue = getParamFromSearch(window.location.search)
    if(searchValue) return searchValue

    const hashQueryIndex = window.location.hash.indexOf('?')
    if(hashQueryIndex === -1) return null

    return getParamFromSearch(window.location.hash.slice(hashQueryIndex))
}

function removeDirectAccessKeyFromUrl() {
    const url = new URL(window.location.href)
    DIRECT_ACCESS_QUERY_PARAMS.forEach((param) => url.searchParams.delete(param))

    const hashQueryIndex = url.hash.indexOf('?')
    if(hashQueryIndex !== -1) {
        const hashPath = url.hash.slice(0, hashQueryIndex)
        const hashParams = new URLSearchParams(url.hash.slice(hashQueryIndex + 1))

        DIRECT_ACCESS_QUERY_PARAMS.forEach((param) => hashParams.delete(param))

        const hashQuery = hashParams.toString()
        url.hash = hashQuery ? `${hashPath}?${hashQuery}` : hashPath
    }

    window.history.replaceState({}, document.title, url.toString())
}

function getDirectAccessKey() {
    const directAccessKey = getDirectAccessKeyFromUrl()
    if(directAccessKey) {
        sessionStorage.setItem(DIRECT_ACCESS_STORAGE_KEY, directAccessKey)
        removeDirectAccessKeyFromUrl()
        return directAccessKey
    }

    return sessionStorage.getItem(DIRECT_ACCESS_STORAGE_KEY)
}

function createDirectAccessAuth(accessKey) {
    return {
        token: accessKey,
        directAccess: true,
        loadUserProfile: () => ({
            success: (callback) => {
                callback({ firstName: 'Acesso direto' })
            }
        }),
        logout: () => {
            sessionStorage.removeItem(DIRECT_ACCESS_STORAGE_KEY)
            window.location.reload()
        }
    }
}

export default function Keycloak({children}) {

    const [kc, setKc] = useState({})
    const [authenticating, setAuthenticating] = useState(true)

    useEffect(() => {

        const directAccessKey = getDirectAccessKey()
        if(directAccessKey) {
            setKc(createDirectAccessAuth(directAccessKey))
            setAuthenticating(false)
            return
        }

        if(DISABLE_AUTH) return

        console.log(process.env.REACT_APP_KEYCLOAK_ADDRESS)

        setAuthenticating(true)

        let keycloak = KeycloakJS({
            url: `${process.env.REACT_APP_KEYCLOAK_ADDRESS}/auth`,
            clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID,
            realm: process.env.REACT_APP_KEYCLOAK_REALM
        })

        keycloak.onAuthError = (error) => {
            console.log('Error autenticating')

            alert(error)
        }

        let updateInterval = null


        keycloak.init({onLoad:'login-required'}).then((authenticated) => {

            console.log('autenticado', authenticated)

            localStorage.setItem('auth', 'true')

            setAuthenticating(false)

            updateInterval = setInterval(() => {
                keycloak.updateToken(30).error((error) => console.log('Erro ao atualizar o token:', error))
            }, TOKEN_UPDATE_TIME)
        })


        // backend.setAuthInfo(keycloak)

        setKc(keycloak)
        // eslint-disable-next-line

        return () => {
            clearInterval(updateInterval)
        }

        // eslint-disable-next-line
    }, [])

    if(DISABLE_AUTH)
        return children

    return <KeycloakContext.Provider value={kc}>
                {authenticating ? <Loading show={true}></Loading> : children}
           </KeycloakContext.Provider>

    // return children
}
